<template>
    <div>
        <CollapseConfirmData
            :code-id="code"
            :isShowButton="false"
        >
            <template #content>
                <ResultList class="text-base xs:text-lg">
                    <div class="p-3.5 md:px-5">
                        <div class="mb-3.5 md:md-5">
                            <div class="font-bold text-green-600 md:mb-2.5">
                                投資屬性類型
                            </div>
                            <div class="text-gray-900">
                                {{ after.investType }}
                            </div>
                        </div>
                        <div
                            v-if="after.investType!=='不適合購買型'"
                            class="mb-3.5 md:md-5"
                        >
                            <div class="font-bold text-green-600 md:mb-2.5">
                                適合基金風險類型
                            </div>
                            <div class="text-gray-900">
                                {{ after.investLevel }}
                            </div>
                        </div>
                        <div>
                            <div class="font-bold text-green-600 md:mb-2.5">
                                說明
                            </div>
                            <div class="text-gray-900">
                                {{ after.investContent }}
                            </div>
                        </div>
                    </div>
                </ResultList>
            </template>
        </CollapseConfirmData>
    </div>
</template>

<script>
import { ref, toRef, reactive } from 'vue';
import CollapseConfirmData from '@/components/collapse/CollapseConfirmData.vue';
import ResultList from '@/components/template/ResultList.vue';

export default {
    name: 'IQData',
    components: {
        CollapseConfirmData,
        ResultList
    },
    props: {
        result: {
            type: Object,
            required: true,
        }
    },
    setup(props) {
        const data = toRef(props, 'result');
        const after = reactive(data.value.after);
        const code = ref('IQ');
        return { code, after };
    },
};
</script>
